module.exports = __webpack_public_path__ + "fonts/VetoSansCond-MediumItalic.6d03d51c.woff2";